



































import { Emit, Prop, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";

@Component
export default class MenuLayoutPage extends Vue {
  drawer = true;
  @Prop() menus: Record<string, string>[];
  mini = false;

  get selectMenu() {
    let id = 0;
    for (let menu of this.menus) {
      if (menu.routeName === this.$route.name) {
        return id;
      }
      id++;
    }
    return -1;
  }

  @Watch('mini')
  @Emit()
  onMiniChange() {
    return this.mini;
  }

  @Emit()
  onMenuChange(val) {}

  onRadioButtonClick(menu) {
    if (this.$route.name !== menu.routeName) {
      this.$router.push({ name: menu.routeName });
    }
  }
}
